import { clearLocalStorageValue } from "util/localStorageHelper";
import api from "api/api";
import { showSnackbar } from "containers/Shared/Notifier/actions";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import globalAxios from "axios";
import { resolveRootManagePath } from "utils/adminLinkHelpers";
import AuthService from "utils/authService";
import { axios } from "utils/axios";
import history from "utils/history";
import { router } from "router";
import messages from "./messages";
import {
  FETCH_USER_DATA_BEGIN,
  LOGIN_BEGIN,
  LOGOUT_BEGIN,
  PUSH_REDIRECT,
  SSO_LINK_BEGIN,
  SSO_LOGIN_BEGIN,
} from "./constants";
import {
  fetchUserDataError,
  fetchUserDataSuccess,
  loginError,
  loginSuccess,
  logoutError,
  logoutSuccess,
  setUserData,
} from "./actions";

export function* login(action) {
  try {
    // Create a new session given credentials & dispatch a loggedIn action
    // payload is user credentials
    const response = yield call(
      api.sessions.create.bind(api.sessions),
      action.payload,
    );

    const { token } = response.data;

    yield put(loginSuccess(token));
    axios.defaults.headers.common["Diverst-UserToken"] = token;
    globalAxios.defaults.headers.common["Diverst-UserToken"] = token;

    yield call(AuthService.storeJwt, token);
    void router.navigate({ to: action.payload.referrer || "/" });
  } catch (err) {
    yield put(loginError(err));

    if (err.response.status === 401) {
      yield put(
        showSnackbar({
          message: messages.errors.loginIncorrect,
          options: { variant: "error" },
        }),
      );
    } else {
      yield put(
        showSnackbar({
          message: messages.errors.loginGeneric,
          options: { variant: "error" },
        }),
      );
    }
  }
}

export function* ssoLogin(action) {
  try {
    axios.defaults.headers.common["Diverst-UserToken"] =
      action.payload.userToken;
    globalAxios.defaults.headers.common["Diverst-UserToken"] =
      action.payload.userToken;
    yield put(loginSuccess(action.payload.userToken));

    yield call(AuthService.storeJwt, action.payload.userToken);

    void router.navigate({
      to: action.payload.RelayState || "/",
    });
  } catch (err) {
    yield put(loginError(err));
    yield put(showSnackbar({ message: err }));
  }
}

export function* ssoLinkFind(action) {
  try {
    const response = yield call(
      api.enterprises.getSsoLink.bind(api.enterprises),
      action.payload.enterpriseId,
      { relay_state: action.payload.referrer },
    );
    window.location.assign(response.data);
  } catch (err) {
    yield put(loginError(err));
    yield put(showSnackbar({ message: err.response.data }));
  }
}

export function* logout() {
  try {
    // Destroy session and redirect to login
    const response = yield call(api.sessions.logout.bind(api.sessions));

    yield call(AuthService.discardJwt);
    yield put(logoutSuccess());

    if (response.data.logout_link) {
      window.location.assign(response.data.logout_link);
    } else {
      yield put(
        showSnackbar({
          message: messages.success.logout,
          options: { variant: "info" },
        }),
      );
    }
  } catch (err) {
    yield put(logoutError(err));

    // Even if logout fails clear the local data
    yield call(AuthService.discardJwt);
    yield put(logoutSuccess());

    yield put(
      showSnackbar({
        message: messages.success.logout,
        options: { variant: "info" },
      }),
    );
  }
  clearLocalStorageValue("custom_texts");
  clearLocalStorageValue("custom_texts_expiry");
}

export function* fetchUserData() {
  try {
    const response = yield call(api.user.getUserData.bind(api.user));

    const payload = response.data;

    payload.permissions.adminPath = resolveRootManagePath(payload.permissions);
    yield put(setUserData(payload));

    yield put(fetchUserDataSuccess());
  } catch (err) {
    yield put(fetchUserDataError(err));
  }
}

export function* pushRedirect(action) {
  yield call(history.push, action.path);
}

export default function* handleLogin() {
  yield takeLatest(LOGIN_BEGIN, login);

  yield takeLatest(SSO_LINK_BEGIN, ssoLinkFind);

  yield takeLatest(SSO_LOGIN_BEGIN, ssoLogin);

  yield takeLatest(LOGOUT_BEGIN, logout);

  yield takeLatest(FETCH_USER_DATA_BEGIN, fetchUserData);

  yield takeEvery(PUSH_REDIRECT, pushRedirect);
}
